export enum EmailTypeEnum {
  OnlineOrderSignUp = 'OnlineOrderSignUp',
  OnlineOrderRefund = 'OnlineOrderRefund',
  StaffCard = 'StaffCard',
  GiftCardRegistration = 'GiftCardRegistration',
  OnlineOrderConfirmation = 'OnlineOrderConfirmation',
  GiftCardReceipt = 'GiftCardReceipt',
  GiftcardRefund = 'GiftcardRefund',
  PhysicalGiftCardPosted = 'PhysicalGiftCardPosted',
  PhysicalGiftCard = 'PhysicalGiftCard',
  PurchasingOrder = 'PurchasingOrder',
  CreditNote = 'CreditNote',
  DigitalGiftCard = 'DigitalGiftCard',
  InvoiceEmail = 'InvoiceEmail',
  InvoiceBillingEmail = 'InvoiceBillingEmail',
  PoSystemOrderEmail = 'PoSystemOrderEmail',
  ReturnPurchasingOrder = 'ReturnPurchasingOrder',
  CreditNotePurchasingOrder = 'CreditNotePurchasingOrder',
}
